import { AppBadges } from '@gasbuddy/react-consumer-components';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { localyticsEvent } from '../../../lib/utils';
import { ANALYTICS_EVENTS } from '../../constants';

export default function AppBadgesWithAnalytics({ analyticsScreenName, ...rest }) {
  const handleAppStoreClick = useCallback(() => {
    localyticsEvent(ANALYTICS_EVENTS.APP_STORE_LINK_CLICK, { Store: 'iTunes', 'Screen Name': analyticsScreenName });
  }, [analyticsScreenName]);

  const handlePlayStoreClick = useCallback(() => {
    localyticsEvent(ANALYTICS_EVENTS.APP_STORE_LINK_CLICK, { Store: 'PlayStore', 'Screen Name': analyticsScreenName });
  }, [analyticsScreenName]);

  return (
    <AppBadges
      appStoreData={{
        name: 'iOSAppRating',
        rating: 4.5,
        reviewCount: '380,000+',
      }}
      onAppStoreClick={handleAppStoreClick}
      onPlayStoreClick={handlePlayStoreClick}
      playStoreData={{
        name: 'androidAppRating',
        rating: 4.5,
        reviewCount: '770,000+',
      }}
      {...rest}
    />
  );
}

AppBadgesWithAnalytics.propTypes = {
  analyticsScreenName: PropTypes.string.isRequired, // TODO: consider using useContext to set this value
};
